<div class="risk-factors-popover">
  <p
    [style.color]="
      turnoverRiskStratificationColors[caregiver.turnoverRiskStratification]
    "
  >
    <strong>{{
      turnoverRiskStratificationDescriptions[
        caregiver.turnoverRiskStratification
      ]
    }}</strong>
  </p>
  @if (factors.length > 0) {
  <p><strong>Top Risk Factors</strong></p>
  <ol>
    @for (factor of factors; track factor) {
    <li>
      {{ factor }}
    </li>
    }
  </ol>
  } @if (factors.length === 0) {
  <p><strong>No Risk Factors</strong></p>
  }
</div>
